// #Cursor JavaScript Place Here#
document.addEventListener("DOMContentLoaded", function() {
    const cursor = document.getElementById("cursor");
    cursor.style.margin = "-9px"; // Apply margin when page loads
    document.addEventListener("mousemove", (e)=>{
        cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        cursor.style.opacity = "1";
    });
    document.querySelectorAll('.button-hover, a, h1, img, button').forEach((el)=>{
        el.addEventListener("mouseenter", ()=>{
            cursor.style.width = "50px";
            cursor.style.height = "50px";
            cursor.style.margin = "-20px"; // Apply margin only when enlarged
        });
        el.addEventListener("mouseleave", ()=>{
            cursor.style.width = "20px";
            cursor.style.height = "20px";
            cursor.style.margin = "-9px"; // Reset margin when back to normal
        });
    });
    // Optional: Hide cursor near edges
    document.addEventListener("mousemove", function(e) {
        const edgeBuffer = 10;
        if (e.clientX <= edgeBuffer || e.clientY <= edgeBuffer || e.clientX >= window.innerWidth - edgeBuffer || e.clientY >= window.innerHeight - edgeBuffer) cursor.style.opacity = "0";
        else cursor.style.opacity = "1";
    });
});


/*=============== SHOW MENU ===============*/ const $13afcb55df31c6b4$var$navMenu = document.getElementById('nav-menu'), $13afcb55df31c6b4$var$navToggle = document.getElementById('nav-toggle'), $13afcb55df31c6b4$var$navClose = document.getElementById('nav-close');
/* Menu show */ if ($13afcb55df31c6b4$var$navToggle) $13afcb55df31c6b4$var$navToggle.addEventListener('click', ()=>{
    $13afcb55df31c6b4$var$navMenu.classList.add('show-menu');
});
/* Menu hidden */ if ($13afcb55df31c6b4$var$navClose) $13afcb55df31c6b4$var$navClose.addEventListener('click', ()=>{
    $13afcb55df31c6b4$var$navMenu.classList.remove('show-menu');
});




const $117ba2f2658d567e$var$buttons = document.querySelectorAll(".faq-btn");
$117ba2f2658d567e$var$buttons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        const currentAnswer = button.nextElementSibling;
        const icon = button.querySelector(".d-arrow");
        // Close all other answers
        document.querySelectorAll(".faq-answer").forEach((answer)=>{
            if (answer !== currentAnswer) {
                answer.style.height = "0px";
                answer.classList.remove("open");
            }
        });
        // Reset all icons
        document.querySelectorAll(".d-arrow").forEach((i)=>{
            if (i !== icon) i.classList.remove("rotate");
        });
        // Toggle this one
        if (currentAnswer.classList.contains("open")) {
            currentAnswer.style.height = "0px";
            currentAnswer.classList.remove("open");
            icon.classList.remove("rotate");
        } else {
            currentAnswer.style.height = currentAnswer.scrollHeight + "px";
            currentAnswer.classList.add("open");
            icon.classList.add("rotate");
        }
    });
});


const $c10dd66d2c40f4a4$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) entry.target.classList.add('show');
    });
});
const $c10dd66d2c40f4a4$var$hiddenElements = document.querySelectorAll('.hidden');
$c10dd66d2c40f4a4$var$hiddenElements.forEach((el)=>$c10dd66d2c40f4a4$var$observer.observe(el));


document.addEventListener('DOMContentLoaded', function() {
    // Run only on homepage
    const isHomePage = window.location.pathname.endsWith('/') || window.location.pathname.endsWith('/index.html');
    if (!isHomePage) return;
    const scrollBtn = document.getElementById('scrollToNext');
    if (!scrollBtn) return;
    scrollBtn.addEventListener('click', function() {
        const scrollOffset = window.innerHeight * 1;
        const targetY = window.scrollY + scrollOffset;
        window.scrollTo({
            top: targetY,
            behavior: 'smooth'
        });
    });
});


(function() {
    const KEY = 'dby-popup-b-dismissed';
    if (sessionStorage.getItem(KEY)) return;
    const modalHTML = `
  <div class="dby-pb-overlay" id="dbyPopupBOverlay">
    <div class="dby-pb" id="dbyPopupB" role="dialog" aria-modal="true" aria-label="Showcase offer">
      <button class="pb-close" id="dbyPopupBClose" aria-label="Close">&times;</button>
      <div class="pb-brand">
        <svg class="pb-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 18L18 6M18 6H9M18 6V15" stroke="#2E46FA" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>DevBehindYou</span>
      </div>
      <p class="pb-headline">This website is a showcase build.</p>
      <p class="pb-copy">Get the full source code, CRM, and SEO services \u{2014} plus 5 free AI-SEO optimized blogs.</p>
      <a class="pb-cta" href="https://devbehindyou.vercel.app/contact" target="_blank" rel="noopener">
        <span class="pb-cap"></span>
        <span class="pb-body">
          <span class="pb-label">Free with every project</span>
          <span class="pb-title">5 AI-SEO Optimized Blogs</span>
        </span>
      </a>
    </div>
  </div>`;
    const div = document.createElement('div');
    div.innerHTML = modalHTML;
    document.body.appendChild(div.firstElementChild);
    const overlay = document.getElementById('dbyPopupBOverlay');
    const closeBtn = document.getElementById('dbyPopupBClose');
    let lastFocused = null;
    function show() {
        lastFocused = document.activeElement;
        overlay.classList.add('is-visible');
        closeBtn.focus();
    }
    function hide() {
        overlay.classList.remove('is-visible');
        sessionStorage.setItem(KEY, '1');
        if (lastFocused) lastFocused.focus();
    }
    setTimeout(show, 10000);
    closeBtn.addEventListener('click', hide);
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) hide();
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-visible')) hide();
    });
})();




//# sourceMappingURL=repo.56273215.js.map
